import getAllInfoByISO from './getAllInfoByISO'
import places from './places'

export interface Place {
  address_components: {
    types: string[]
    short_name: string
  }[]
}
export interface SplitAddressComponentArgs {
  place: Place
}

export default ({ place }: SplitAddressComponentArgs) => {
  let address1 = ''
  let city = ''
  let state = ''
  let country = ''
  let zipCode = ''
  let zipCodeSuffix = ''
  let currency = ''

  if (place.address_components) {
    let streetNumberComponent = place.address_components.filter((ac) =>
      ac.types.includes(places.types.streetNumber)
    )[0]
    if (!streetNumberComponent) {
      streetNumberComponent = place.address_components.filter((ac) =>
        ac.types.includes('premise')
      )[0]
    }
    let routeComponent = place.address_components.filter((ac) =>
      ac.types.includes(places.types.route)
    )[0]
    if (!routeComponent) {
      routeComponent = place.address_components.filter((ac) =>
        ac.types.includes(places.types.sublocality)
      )[0]
    }
    let localityComponent = place.address_components.filter((ac) =>
      ac.types.includes(places.types.locality)
    )[0]
    if (!localityComponent) {
      localityComponent = place.address_components.filter((ac) =>
        ac.types.includes(places.types.sublocality)
      )[0]
    }
    const stateComponent = place.address_components.filter((ac) =>
      ac.types.includes(places.types.state)
    )[0]
    const countryComponent = place.address_components.filter((ac) =>
      ac.types.includes(places.types.country)
    )[0]
    const zipCodeComponent = place.address_components.filter((ac) =>
      ac.types.includes(places.types.postalCode)
    )[0]
    const zipCodeSuffixComponent = place.address_components.filter((ac) =>
      ac.types.includes(places.types.postalCodeSuffix)
    )[0]
    const iso2 = countryComponent && countryComponent.short_name

    address1 = [
      (streetNumberComponent && streetNumberComponent.short_name) || '',
      (routeComponent && routeComponent.short_name) || '',
    ].join(' ')
    city = (localityComponent && localityComponent.short_name) || ''
    state = (stateComponent && stateComponent.short_name) || ''
    country = (countryComponent && countryComponent.short_name) || ''
    zipCode = (zipCodeComponent && zipCodeComponent.short_name) || ''
    zipCodeSuffix =
      (zipCodeSuffixComponent && zipCodeSuffixComponent.short_name) || ''
    if (iso2) {
      currency = getAllInfoByISO(iso2)?.iso
    }
  }
  const formattedZip =
    zipCode && zipCodeSuffix ? `${zipCode}-${zipCodeSuffix}` : zipCode

  const locationObjectConstruct = {
    address1,
    city,
    country,
    currency,
    zipCode: formattedZip,
    state,
  }

  return locationObjectConstruct
}
